import { render, staticRenderFns } from "./custdetail_general.vue?vue&type=template&id=87735454"
import script from "./custdetail_general.ts?vue&type=script&lang=js&external"
export * from "./custdetail_general.ts?vue&type=script&lang=js&external"
import style0 from "./custdetail_general.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports